module.exports = __webpack_public_path__ + "img/ccid.292b86e1.png";